/**
 * jQuery Slick Carousel Products
 * @type {exports|HTMLElement|*}
 */
export const productsCategoriesCarousel = ($productsCategoriesCarousel) => {
    if ($productsCategoriesCarousel) {
        // Apply reveal class
        $productsCategoriesCarousel.on('init', (slick) => {
            const slides = slick.currentTarget.querySelectorAll('.slick-slide');
            if (slides.length) {
                slides.forEach(slide => {
                   slide.classList.add('has-reveal');
                });
            }
        })
        $productsCategoriesCarousel.slick({
            infinite: false,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
}

export const productsCarousel = ($productsCarousel) => {
    if ($productsCarousel) {
        $productsCarousel.slick({
            infinite: false,
            speed: 300,
            arrows: false,
            dots: true,
            dotsClass: 'products-carousel__nav mt-5',
            responsive: [
                {
                    breakpoint: 999999,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }
}

export const productGallery = ($productGallery) => {
    if ($productGallery) {
        $productGallery.slick({
            infinite: false,
            speed: 300,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            dotsClass: 'product-gallery__nav',
            responsive: [
                {
                    breakpoint: 999999,
                    settings: "unslick",
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ]
        });
    }
}

export const relatedProducts = ($relatedProducts) => {
    if ($relatedProducts) {
        $relatedProducts.slick({
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            dotsClass: 'related-products__nav mt-5',
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
            ]
        });
    }
}

export const familyCarousel = ($familyCarousel) => {
    if ($familyCarousel) {
        $familyCarousel.slick({
            infinite: false,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: false,
            dots: true,
            dotsClass: 'family-carousel__nav mt-5',
            responsive: [
                {
                    breakpoint: 999999,
                    settings: {
                        centerMode: true,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        centerMode: false,
                    }
                }
            ]
        });
    }
}

export const sliderCarousel = ($sliderCarousel) => {
    if ($sliderCarousel) {
        $sliderCarousel.slick({
            infinite: false,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: true,
            dots: true,
            dotsClass: 'slider-carousel__nav mt-5',
        });
    }
}

